import { createIcon } from '@chakra-ui/react';

export const MegaPhoneOutline = createIcon({
  displayName: 'MegaPhone',
  viewBox: '0 0 32 31.144',
  path: (
    <path
      id="Megaphone_-_L-2"
      data-name="Megaphone - L"
      d="M30.142,16.693a.829.829,0,0,0,.168,0,2.5,2.5,0,0,0,2.308-2.212A2.524,2.524,0,0,0,30.9,11.767V3.5a1.475,1.475,0,0,0-.56-1.173,1.5,1.5,0,0,0-1.333-.27h-.051L13.861,7.3H7.28a6.759,6.759,0,0,0-6.6,6.075A6.833,6.833,0,0,0,5.789,20.8l2.5,10.554a2.28,2.28,0,0,0,2.2,1.8A2.347,2.347,0,0,0,11,33.087l1.288-.317a2.263,2.263,0,0,0,1.4-1.042,2.344,2.344,0,0,0,.265-1.751L11.86,21H13.7l15.269,5.233h.051a1.659,1.659,0,0,0,.392.052,1.507,1.507,0,0,0,.926-.311,1.485,1.485,0,0,0,.57-1.168V18.386a.764.764,0,1,0-1.527,0V24.75L14.929,19.787V8.564l14.459-5V15.92a.766.766,0,0,0,.753.773ZM12.527,30.336a.776.776,0,0,1-.092.581.765.765,0,0,1-.468.348l-1.293.327a.758.758,0,0,1-.911-.566L7.387,21h2.921Zm-5.09-10.9H7.28a5.306,5.306,0,0,1,0-10.611h6.138V19.455Z"
      transform="translate(-0.636 -2.005)"
      fill="currentColor"
    />
  ),
});

export const MegaPhoneSolid = createIcon({
  displayName: 'MegaPhone',
  viewBox: '0 0 18 17.137',
  path: (
    <path
      id="Megaphone_-_S-2"
      data-name="Megaphone - S"
      d="M18.527,7.571a1.936,1.936,0,0,0-1.033-1.64V2.059a1.263,1.263,0,0,0-.492-1A1.312,1.312,0,0,0,15.788.845L7.864,3.519H4.584a4.035,4.035,0,0,0-1.214,7.89l1.214,5.184a1.64,1.64,0,0,0,1.64,1.312,1.64,1.64,0,0,0,.394,0l.673-.164h0a1.755,1.755,0,0,0,1.066-.771,1.64,1.64,0,0,0,.2-1.3L7.6,11.623h.262l7.989,2.641a1.247,1.247,0,0,0,.344,0,1.329,1.329,0,0,0,.8-.279,1.28,1.28,0,0,0,.492-1.017V9.228A1.9,1.9,0,0,0,18.527,7.571Zm-2.854.787a12.762,12.762,0,0,0,0,1.394v2.575L9.111,10.113V5.045l6.562-2.264Z"
      transform="translate(-0.527 -0.781)"
      fill="currentColor"
    />
  ),
});
